export const DEV_PAGE = "DEV_PAGE";
export const getDevPage = (data) => {
    return {
        type: DEV_PAGE,
        payload: data
    }
}